import dayjs from 'dayjs';

export const DAILY_DATE_FORMAT = {
  DASH: 'YYYY-MM-DD',
  DOT: 'YYYY. M. D'
};

export const MONTHLY_DATE_FORMAT = {
  DASH: 'YYYY-MM',
  DOT: 'YYYY. M'
};

// 1월인 경우 작년 1월이 시작월이 된다
export const SETTLE_START_MONTH_FORMATTED_STR = dayjs().subtract(1, 'month').startOf('year').format('YYYY-MM');
export const SETTLE_PREV_MONTH_FORMATTED_STR = dayjs().subtract(1, 'month').format('YYYY-MM');
